// extracted by mini-css-extract-plugin
export var contentBody = "_c7-9";
export var headerImage = "_c7-2";
export var imageButton = "_c7-7";
export var imageButtonIcon = "_c7-8";
export var imageHeader = "_c7-4";
export var imageHeaderText = "_c7-5";
export var imageOverlay = "_c7-3";
export var imageTitle = "_c7-6";
export var imageWrapper = "_c7-1";
export var taskList = "_c7-a";
export var widget = "_c7-0";